export const ifNonEmptyInput = (text) => {
   return (text && /\S/.test(text));
}